import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}

import { computed, getCurrentInstance, onMounted, onUnmounted, ref } from "vue";
import Loading from "./../Loading/index.ts";
import Login from "./../Login/index.ts";
import Videos from "../Videos/index.ts";
import Main from "./../Main/index.ts";
import Checkout from "./../Checkout/index.ts";
import CourseCategory from "../CourseCategory/index.ts";
import LoginReturn from "../LoginReturn/index.ts";

interface Props {
  theme: string; // light/dark
  view: string; // Steuert spezifische Ansichten (default: Main)
  courseId: number | null; // Triggert die Ansicht des Checkouts
  categoryId: number | null; // Triggert die Ansicht nur einer Kategorie
  accent: string; // Akzentfarbe der Tanzschule (leer = Standard)
  font: string; // Schriftfamilie (leer = Standard)
  overlay: boolean; // Checkout als eigener, bildschirmfuellender Dialog (statt im Container der Website)
}
export default {
  template: html,
  components: {
    Loading,
    Login,
    Videos,
    Main,
    Checkout,
    CourseCategory,
    LoginReturn,
  },
  props: {
    categoryId: { type: Number, required: false },
    courseId: { type: Number, required: false },
    theme: { type: String, required: true },
    view: { type: String, required: true },
    accent: { type: String, required: false, default: "" },
    font: { type: String, required: false, default: "" },
    overlay: { type: Boolean, required: false, default: false },
  },
  setup(props: Props) {
    const instance = getCurrentInstance();
    const courseName = ref("");
    let previousOverflow = "";

    // Branding pro Website ueber CSS-Variablen; nur gueltige Farbwerte uebernehmen
    const rootStyle = computed(function () {
      const style: Record<string, string> = {};
      const accent = (props.accent || "").trim();
      if (/^#[0-9a-fA-F]{3,8}$/.test(accent) || /^(rgb|hsl)a?\([^)]*\)$/.test(accent)) {
        style["--tsm-accent"] = accent;
        style["--tsm-primary"] = accent;
        style["--bs-primary"] = accent;
      }
      const font = (props.font || "").trim();
      if (font != "" && font.length < 120 && !/[;{}<>]/.test(font)) {
        style["--tsm-font"] = font;
      }
      return style;
    });

    const useOverlay = computed(() => props.overlay && props.view == "Checkout");

    // Dialog schliessen: Ereignis an die Website und das Element selbst entfernen
    const close = function () {
      const el = instance?.proxy?.$el as Node | null | undefined;
      const rootNode = el?.getRootNode?.() as ShadowRoot | Document | undefined;
      const host = rootNode && "host" in rootNode ? (rootNode as ShadowRoot).host : null;
      if (host) {
        host.dispatchEvent(new CustomEvent("tsm-close", { bubbles: true, composed: true }));
        host.remove();
      }
    };

    const onKey = function (e: KeyboardEvent) {
      if (e.key == "Escape" && useOverlay.value) {
        close();
      }
    };

    onMounted(function () {
      if (useOverlay.value) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
      }
    });
    onUnmounted(function () {
      if (useOverlay.value) {
        document.body.style.overflow = previousOverflow;
        window.removeEventListener("keydown", onKey);
      }
    });

    return {
      props,
      rootStyle,
      useOverlay,
      courseName,
      close,
      onCourse: (name: string) => (courseName.value = name),
    };
  },
};
